import { render, staticRenderFns } from "./ImportEmployees.vue?vue&type=template&id=18618052&scoped=true&"
import script from "./ImportEmployees.vue?vue&type=script&lang=js&"
export * from "./ImportEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ImportEmployees.vue?vue&type=style&index=0&id=18618052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18618052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDataTable,VFlex,VIcon,VLayout,VSnackbar,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
